import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import RelanceFactureModel from "../models/RelanceFactureModel";

export const base_url = "http://localhost:8000/api/v1/";

export function useGetRelanceFacture(perPageDefault = 2) {
    const [relances, setRelances] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const perPage = perPageDefault;
    const [pagination, setPagination] = useState({
        total: 0,
        per_page: perPage,
        current_page: 1,
        last_page: 1,
    });

    const token = useSelector((state) => state.auth.token);
    const navigate = useNavigate();

    const fetchRelances = useCallback(async (customPage = 1) => {
        if (!token) {
            navigate("/login");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(
                `${base_url}relances/factures?page=${customPage}&per_page=${perPage}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error("Erreur lors de la récupération des relances facture");

            const data = await response.json();
            //console.log("📥 API RESPONSE brut:", data);

            // On mappe chaque facture + relances dans le modèle
            const relancesFormatées = data.relances.map((item) => new RelanceFactureModel(item));
            //console.log("📥 relancesFormatées API RESPONSE brut:", relancesFormatées);

            setRelances(relancesFormatées);
            setPagination({
                total: data.total,
                per_page: data.per_page,
                current_page: data.current_page,
                last_page: data.last_page || Math.ceil(data.total / data.per_page),
            });
        } catch (error) {
            console.error("Erreur:", error);
            setRelances([]);
            setPagination({
                total: 0,
                per_page: perPage,
                current_page: 1,
                last_page: 1,
            });
        } finally {
            setLoading(false);
        }
    }, [token, perPage, navigate]);

    useEffect(() => {
        fetchRelances(page);
    }, [fetchRelances, page]);

    return {
        relances,
        loading,
        pagination,
        page,
        setPage,
        fetchRelances,
        setRelances,
        setLoading,
        setPagination,
    };
}



// ✅ Fonction pour récupérer une relance facture par ID
export async function getRelanceFactureById(id, token) {
    if (!token) throw new Error("Utilisateur non authentifié");

    try {
        const response = await fetch(`${base_url}relances/facture/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error("Erreur lors de la récupération de la relance facture");

        const data = await response.json();
        return new RelanceFactureModel(data.relance);
    } catch (error) {
        console.error("Erreur getRelanceFactureById:", error);
        return null;
    }
}
// Fonction pour envoyer une relance pour une facture spécifique
export async function envoyerRelanceFacture(factureId, data, token) {
    if (!token) throw new Error("Utilisateur non authentifié");

    try {
        const response = await fetch(`${base_url}relances/facture/${factureId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data), // { subject, message }
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.error || "Erreur lors de l’envoi de la relance");
        }

        return result; // retourne la réponse du backend
    } catch (error) {
        console.error("Erreur envoyerRelanceFacture:", error);
        throw error;
    }
}
